import React, { useEffect, useRef, useState } from 'react';
import '../../../Static/Master/PackPrintStruct.css';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useMediaQuery, Button, CircularProgress } from '@mui/material';
import ReactToPrint from 'react-to-print';
import { Grid, Paper } from '@mui/material';
import { fetchPackingData } from '../../../Store/PHPSlice/Packing/PackApis';
import { selectPackingData } from '../../Selectors/PackSelector/PackingSelector';
import FirmHeaderImg from '../../FieldsComponents/FirmHeaderImg';
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import axios from "axios";


const WhPackPrint = ({ id, hideButtons, data, url, info, partyId, onDone }) => {

    const printRef = useRef();
    const { Id } = useParams();
    const dispatch = useDispatch();
    const componentRef = useRef();
    const [formData, setFormData] = useState(data ||
        {}
    );
    const [packInfo, setPackInfo] = useState(info || []);
    const [isReady, setIsReady] = useState(false);
    const [sending, setSending] = useState(false);
    const [loading, setLoading] = useState(false);
    const packData = useSelector(selectPackingData);
    const [firmUrl, setFirmUrl] = useState('');
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const imgUrl = process.env.REACT_APP_IMAGE_URL;


    useEffect(() => {
        if (
            data &&
            Object.keys(data).length > 0 &&
            info &&
            info.length > 0 &&
            partyId
        ) {
            setTimeout(() => {
                setIsReady(true);
            }, 300);
        }
    }, [data, info, partyId]);

    useEffect(() => {
        if (isReady && !sending) {
            generateAndSendPDF();
        }
    }, [isReady]);


    // useEffect(() => {
    //     if (packData?.data) {
    //         const item = packData?.data;
    //         setFormData(prev => ({
    //             ...prev,
    //             adrs: item.adrs,
    //             dt: item.dt,
    //             eType: item.eType,
    //             firm: item.firmNm,
    //             parcel_qty: item.parcel_qty,
    //             partyNm: item.partyNm,
    //             pkMemo: item.pkMemo,
    //             remark: item.remark,
    //             schoolNm: item.schoolNm,
    //             shipNm: item.shipNm,
    //             ship_adrs: item.ship_adrs,
    //             totqty: item.totqty,
    //             totamt: item.totamt,
    //             transportNm: item.transportNm,
    //             firmAdrs: item.firmAdrs,
    //             gst: item.gst,
    //             firmId: item?.firmId || '',
    //             discnt_type: item.discnt_type,
    //             discnt_val: item.discnt_val,
    //             discnt_amt: item.discnt_amt,
    //             freight_ch: item.freight_ch,
    //             other_ch: item.other_ch,
    //             state_type: item.state_type,
    //             gst_sts: item.gst_sts,
    //             gst_val: item.gst_val,
    //             sgst: item.sgst,
    //             cgst: item.cgst,
    //             igst: item.igst,
    //             netamt: item.netamt,
    //             partyId: item.partyId,
    //         }));
    //         fetchData(item.firmId);
    //     }
    //     if (packData?.Info && packData.Info?.length > 0) {
    //         const info = packData.Info;
    //         setPackInfo(info);
    //     }
    // }, [packData]);


    function numberToWords(num) {
        const below20 = [
            'Zero', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine',
            'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen',
            'Eighteen', 'Nineteen'
        ];
        const tens = [
            '', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'
        ];
        const thousands = ['', 'Thousand', 'Million', 'Billion', 'Trillion'];

        if (num === 0) return below20[0];

        let words = '';

        let i = 0;
        while (num > 0) {
            if (num % 1000 !== 0) {
                words = helper(num % 1000) + (thousands[i] ? ' ' + thousands[i] : '') + ' ' + words;
            }
            num = Math.floor(num / 1000);
            i++;
        }

        return words.trim().toUpperCase();

        function helper(n) {
            if (n === 0) return '';
            if (n < 20) return below20[n];
            if (n < 100) return tens[Math.floor(n / 10)] + (n % 10 !== 0 ? ' ' + below20[n % 10] : '');
            return below20[Math.floor(n / 100)] + ' Hundred' + (n % 100 !== 0 ? ' ' + helper(n % 100) : '');
        }
    }

    // Example usage:
    // console.log(numberToWords(123)); // Output: "One Hundred Twenty Three"
    // console.log(numberToWords(1234567)); // Output: "One Million Two Hundred Thirty Four Thousand Five Hundred Sixty Seven"


    // const generateAndSendPDF = async () => {
    //     // if (!imageLoaded) {
    //     //     alert("Please wait, image still loading...");
    //     //     return;
    //     // }

    //     // Wait to ensure rendering is complete
    //     await new Promise(resolve => setTimeout(resolve, 300));

    //     const element = printRef.current;

    //     const canvas = await html2canvas(element, {
    //         scale: 2,
    //         useCORS: true,
    //         allowTaint: false
    //     });

    //     const imgData = canvas.toDataURL("image/png");

    //     const pdf = new jsPDF("p", "mm", "a4");
    //     const width = pdf.internal.pageSize.getWidth();
    //     const height = (canvas.height * width) / canvas.width;

    //     pdf.addImage(imgData, "PNG", 0, 10, width, height);

    //     // 👉 CREATE PDF BLOB
    //     const pdfBlob = pdf.output("blob");

    //     // ✅ DOWNLOAD PDF LOCALLY
    //     const pdfUrl = URL.createObjectURL(pdfBlob);
    //     const link = document.createElement("a");
    //     link.href = pdfUrl;
    //     link.download = "packing-slip.pdf";
    //     document.body.appendChild(link);
    //     link.click();
    //     document.body.removeChild(link);
    //     URL.revokeObjectURL(pdfUrl);

    //     // ✅ SEND PDF TO SERVER
    //     const formDatas = new FormData();
    //     formDatas.append("file", pdfBlob, "packing-slip.pdf");
    //     formDatas.append("id", Id);

    //     // await axios.post(
    //     //     "https://uniform.smittech.in/api/uniformApi.php?apicall=PackingPrintSendWhatsApp",
    //     //     formDatas
    //     // );

    //     alert("PDF downloaded & sent successfully!");
    // };


    const generateAndSendPDF = async () => {

        // ✅ wait until React finishes rendering the DOM
        await new Promise(resolve => setTimeout(resolve, 400));

        const element = printRef.current;
        if (!element) {
            console.error("Print element not found");
            return;
        }

        const canvas = await html2canvas(element, {
            scale: 2,
            useCORS: true,
            backgroundColor: "#ffffff"
        });

        const imgData = canvas.toDataURL("image/png");

        const pdf = new jsPDF("p", "mm", "a4");
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

        pdf.addImage(imgData, "PNG", 0, 10, pdfWidth, pdfHeight);

        const pdfBlob = pdf.output("blob");

        const formData = new FormData();
        formData.append("file", pdfBlob, "packing-slip.pdf");
        formData.append("id", id);
        setLoading(true);
        try {
            const res = await axios.post(
                `https://uniform.smittech.in/api/uniformApi.php?apicall=PackingPrintSendWhatsApp&partyId=${partyId}`,
                formData
            );
            // console.log(res.data)
            if (res?.data?.status === 'success') {
                alert(res.data.msg);
            } else {
                alert("Failed to send WhatsApp PDF");
            }
        } catch (error) {
            console.error("❌ WhatsApp send failed:", error);
        } finally {
            setLoading(false);
            if (onDone) onDone();
        }

    };

    const igstper = parseFloat(data.gst_val);
    return (

        <Grid item xs={12}>
            <Paper>


                <div ref={printRef} style={{ padding: '1%' }}>
                    {/* Heading */}


                    <img
                        src={url !== "" ? url : firmUrl}
                        alt="Firm Logo"
                        style={{ width: "95%" }}
                    />

                    <h3 className="heading">Delivery Challan SLIP</h3>

                    {/* Upper part: Two tables side by side */}
                    <div className="flex-container">
                        {/* Left Table */}
                        <table>
                            <tbody>
                                <tr>
                                    <td><h2>{data.firmNm}</h2> <br />
                                        {data.firmAdrs}
                                        <br />
                                        <b>GST No.:</b> {data.gst}
                                    </td>
                                </tr>
                                <tr>
                                    <td><h3>TO:</h3> <br />
                                        <b>{data.partyNm}</b> <br />
                                        {data.adrs}
                                    </td>
                                </tr>

                            </tbody>
                        </table>

                        {/* Right Table */}
                        <table>

                            <tbody>

                                <tr>
                                    <td>Slip Memo:</td>
                                    <td>{data.pkMemo}</td>
                                </tr>
                                <tr>
                                    <td>Date:</td>
                                    <td>{data?.date}</td>
                                </tr>
                                <tr>
                                    <td>Transport:</td>
                                    <td>{data.transportNm}</td>
                                </tr>
                                <tr>
                                    <td>Remark:</td>
                                    <td>{data.remark}</td>
                                </tr>
                                <tr>
                                    <td>Parcel Qty:</td>
                                    <td>{data.parcel_qty}</td>
                                </tr>
                                {/* <tr>
                                    <td>Ship To:</td>
                                    <td>{data.shipNm}</td>
                                </tr> */}
                                <tr>
                                    <td>Ship Address:</td>
                                    <td>{data.ship_adrs}</td>
                                </tr>

                            </tbody>
                        </table>
                    </div>

                    {/* Main Table */}
                    {info.length > 0 &&

                        <table className="main-table">
                            <thead>
                                <tr>
                                    <th>SR NO.</th>
                                    <th>PARTICULARS</th>
                                    <th>SIZE</th>
                                    <th>QTY</th>
                                    <th>RATE</th>
                                    <th>AMOUNT</th>
                                </tr>
                            </thead>
                            <tbody>
                                {info.map((item, index) => (
                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{item.itemNm}</td>
                                        <td>{item.size}</td>
                                        <td>{item.qty}</td>
                                        <td>{item.rate}</td>
                                        <td>{item.tot}</td>
                                    </tr>
                                ))}
                                <tr>
                                    <td></td>
                                    <td></td>
                                    <td><b>Total</b></td>
                                    <td><b>{data.totqty}</b></td>
                                    <td></td>
                                    <td><b>{data.totamt}</b></td>
                                </tr>
                            </tbody>
                        </table>
                    }


                    <table className="main-table">

                        <tbody>

                            {/* <tr>
                                <td>GST(%):</td>
                                <td>{data.gst_val}</td>

                            </tr>
                            <tr>
                                <td>Total Quantity:</td>
                                <td>{data?.totqty}</td>
                                <td>Total Amount:</td>
                                <td>{data?.totamt}</td>
                            </tr> */}
                            <tr>

                                <td>IGST({igstper}%):</td>
                                <td>{data.igst}</td>

                                <td>Freight Charges:</td>
                                <td>{data?.freight_ch}</td>

                                {/* <td>Discount Amount {data?.discnt_val}({data?.discnt_type}):</td>
                                <td>{data?.discnt_amt}</td> */}
                            </tr>
                            <tr>
                                <td>CGST ({igstper / 2}%):</td>
                                <td>{data.cgst}</td>
                                <td>Printing Charges:</td>
                                <td>{data?.other_ch}</td>

                            </tr>
                            <tr>
                                <td>SGST ({igstper / 2}%):</td>
                                <td>{data?.sgst}</td>

                                <td>Gross Total:</td>
                                <td>{parseFloat(data?.totamt) + parseFloat(data?.discnt_amt)}</td>

                            </tr>

                            <tr>
                                <td></td>
                                <td></td>

                                <td><b>Grand Total:</b></td>
                                <td><b>{data?.netamt}</b></td>
                            </tr>


                        </tbody>
                    </table>
                </div>


                {/* <button onClick={generateAndSendPDF}>
                    Send WhatsApp PDF
                </button> */}
                {/* {!hideButtons && <Button variant="contained" color="primary" onClick={generateAndSendPDF} disabled={loading === true}>
                    {
                        loading === true ?
                            <><CircularProgress size="20px" /> sending...</> :
                            "Send WhatsApp PDF"
                    }
                </Button>} */}

                {/* <div style={{ margin: '2% 5%' }}>
                    <ReactToPrint
                        trigger={() => <Button variant="contained" color="primary">Print</Button>}
                        content={() => componentRef.current}
                    />
                </div> */}
            </Paper>
        </Grid>
    );
};


export default React.memo(WhPackPrint);
